/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_helpers';

export function BreadCrumbs({ paths }) {
  return (
    <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2">
      <li className="breadcrumb-item">
        <Link to="/dashboard">
          <span className="svg-icon text-muted icon-1x">
            <img
              alt="home"
              src={toAbsoluteUrl('/media/svg/senseworks/house.svg')}
              width={20}
              height={20}
            />
          </span>
        </Link>
      </li>
      {(paths.length > 2 ? paths.slice(1) : paths).map((item, index) => (
        <li key={`bc${index}`} className="breadcrumb-item">
          <Link className="text-muted" to={{ pathname: item.pathname }}>
            {item.title}
          </Link>
        </li>
      ))}
    </ul>
  );
}
